import { IconButton } from '@zep-us/zus';
import { ChevronLeftIcon } from '@zep-us/zus-icons';
interface BackButtonProps {
  onClick: () => void;
  className?: string;
}

/**
 * 뒤로가기 버튼 컴포넌트
 *
 * Step 기반 UI에서 이전 단계로 돌아가는 버튼입니다.
 * ZUS IconButton + ChevronLeftIcon을 사용합니다.
 *
 * Figma 디자인:
 * - variant: transparent
 * - intent: neutral
 * - size: xs (30px)
 */
export function BackButton({
  onClick,
  className
}: BackButtonProps) {
  return <IconButton type="button" variant="transparent" intent="neutral" size="xs" onClick={onClick} className={className} aria-label="뒤로가기" data-sentry-element="IconButton" data-sentry-component="BackButton" data-sentry-source-file="BackButton.tsx">
      <ChevronLeftIcon size="sm" data-sentry-element="ChevronLeftIcon" data-sentry-source-file="BackButton.tsx" />
    </IconButton>;
}